import { Check, AlertCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { STAGE_FORMULES } from "@/data/site";
import { track } from "@/lib/analytics";

export const StageFormules = () => (
  <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24 lg:pb-32" data-testid="stage-formules">
    <Reveal>
      <p className="eyebrow mb-6">Quelle formule vous correspond ?</p>
      <h2 className="font-serif text-3xl sm:text-4xl text-bark leading-tight max-w-2xl mb-4">Trois portes d'entrée, <em className="not-italic text-terra">un seul point à retenir.</em></h2>
      <p className="flex items-start gap-3 text-bark max-w-2xl mb-12 rounded-xl border border-terra/30 bg-terra/5 p-4" data-testid="stage-formules-note">
        <AlertCircle className="w-5 h-5 text-terra shrink-0 mt-0.5" />
        <span>Les tambours <strong>autres que ronds</strong> (ovale, ovoïde, triangle…) et les laçages spéciaux comme l'arbre de vie se réalisent <strong>uniquement en création individuelle</strong>. En groupe, tout le monde crée un tambour rond.</span>
      </p>
    </Reveal>
    <div className="grid md:grid-cols-3 gap-6">
      {STAGE_FORMULES.map((f, i) => (
        <Reveal key={f.titre} delay={i * 0.1}>
          <div className={`h-full rounded-2xl p-8 lg:p-10 flex flex-col ${i === 1 ? "bg-earth grain text-sand" : "bg-card border border-sand-dark"}`} data-testid={`stage-formule-${i}`}>
            <div className="relative z-[2] flex-1">
              <span className={`font-mono text-[10px] uppercase tracking-[0.25em] px-3 py-1.5 rounded-full ${i !== 1 ? "bg-sand-dark text-bark" : "bg-terra text-earth"}`}>{f.badge}</span>
              <h3 className={`font-serif text-3xl mt-6 ${i !== 1 ? "text-bark" : ""}`}>{f.titre}</h3>
              <p className={`font-serif text-xl mt-1 ${i === 0 ? "text-terra" : "text-terra"}`}>{f.prix}</p>
              <ul className={`mt-6 space-y-3 text-sm ${i !== 1 ? "text-fumee" : "text-sand/75"}`}>
                {f.points.map((p) => <li key={p} className="flex gap-3"><Check className="w-4 h-4 text-terra shrink-0 mt-0.5" />{p}</li>)}
              </ul>
            </div>
            {f.to ? (
              <Link to={f.to} onClick={() => track(f.event, { source: "formule" })} data-testid={`stage-formule-cta-${i}`} className="relative z-[2] mt-8 inline-flex self-start items-center gap-2 px-6 py-3 rounded-full text-sm bg-earth text-sand hover:bg-terra hover:text-earth transition-colors duration-300">{f.cta} <ArrowRight className="w-4 h-4" /></Link>
            ) : (
              <a href={f.href} onClick={() => track(f.event, { source: "formule" })} data-testid={`stage-formule-cta-${i}`} className={`relative z-[2] mt-8 inline-flex self-start items-center px-6 py-3 rounded-full text-sm transition-colors duration-300 ${i !== 1 ? "bg-earth text-sand hover:bg-terra hover:text-earth" : "bg-terra text-earth hover:bg-sand hover:text-earth"}`}>{f.cta}</a>
            )}
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
